import _ from "lodash";
import { getSettingValue } from "Utils/ConfigurationUtils";
import { disableEditForMapleBearChildOrg } from "Courses/modules/utils";
import { canManageClassSettingsStudents } from "Settings/modules/SettingsUtils";
import { getFilterObject } from "services/filterList";
import { isBulkActionsEnabled } from "Utils/ACLStoreUtils";

export const ADD_STUDENT_STEPS = Object.freeze({
  ASSIGN_TASKS: "ASSIGN_TASKS",
  ADD_STUDENTS: "ADD_STUDENTS",
});

export const getIsNotFromStudentPortfolio = ({ userType, source }) => {
  return (
    userType === "staff" &&
    !_.includes(["studentPortfolio", "settingStudentTab"], source)
  );
};

export const getStudentsUpdatePermission = ({
  isStudentsRosteredForFuture,
  isFutureAcademicYearSelected,
}) => {
  // Student Addition (or Updation) will be prevented, If no students are rostered from the Admin Portal -
  // - Academic Year Transition Setup

  if (isFutureAcademicYearSelected && !isStudentsRosteredForFuture) {
    return false;
  } else {
    return (
      canManageClassSettingsStudents() && !disableEditForMapleBearChildOrg()
    );
  }
};

export const getTeacherNotesNotificationConfig = () => {
  return getSettingValue({
    name: "FeatureFlag:TeacherNoteTypesForAdminNotification",
  });
};

export const getStudentPortfolioQueryVariablesMemoized = _.memoize(
  params => getCourseStudentPortfolioVariables(params),
  params => JSON.stringify(params)
);

export const getCourseStudentPortfolioVariables = ({
  courseId,
  studentFilters,
  academicYearId,
  staffRelationFilters,
  orderBy,
  orderByDirection,
}) => {
  const isBulkActionsFeatureEnabled = isBulkActionsEnabled();

  const courseStudentPortfolioFilters = getFilterObject(studentFilters);
  const courseStudentPortfolioFiltersWithoutSearch = {
    ...courseStudentPortfolioFilters,
    searchText: "",
  };

  return {
    id: courseId,
    filters: courseStudentPortfolioFilters,
    ...(isBulkActionsFeatureEnabled
      ? { filtersWithoutSearch: courseStudentPortfolioFiltersWithoutSearch }
      : {}),
    postFilters: {
      state: "PUBLISHED",
      isAllCoursesPost: true,
    },
    courseMapFilters: {
      courseIds: [courseId],
    },
    academicYearId,
    staffRelationFilters,
    orderBy,
    orderByDirection,
  };
};
